import { render, staticRenderFns } from "./PersonalLoanCaseCard.vue?vue&type=template&id=06177554"
import script from "./PersonalLoanCaseCard.vue?vue&type=script&lang=js"
export * from "./PersonalLoanCaseCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports